import React from "react";
import { useCaseListStore } from "../../hooks/useCaseListStore";
import RangeSlider from "./fields/RangeSlider";
import { List, ListItem } from "@mui/material";
import MultiSelectSearch from "./fields/MultiSelectSearch";
import SearchOptionGroup from "./fields/SearchOptionGroup";
import DatePickerFilter from "./fields/DatePickerFilter";
import DateRange from "./fields/DateRange";
import SingleSelect from "./fields/SingleSelect";

export default function Filters({ filters, updateFilter, bulkUpdateFilters }) {
  const filterState = useCaseListStore((state) => state.filterUI);
  const state = useCaseListStore((state) => state);

  const setRangeSliderMinValue = useCaseListStore((state) => {
    return state.setRangeSliderMinValue;
  });
  const setRangeSliderMaxValue = useCaseListStore((state) => {
    return state.setRangeSliderMaxValue;
  });

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const renderFilterUI = (filt) => {
    switch (filterState[filt].filterType) {
      case "RangeSlider":
        return (
          <RangeSlider
            id={filt}
            fieldName={filterState[filt].fieldName}
            title={filterState[filt].title}
            minValue={filterState[filt].currentValues.__gte}
            maxValue={filterState[filt].currentValues.__lte}
            setMinValue={setRangeSliderMinValue}
            setMaxValue={setRangeSliderMaxValue}
            formatter={formatter}
            bulkUpdateFilters={bulkUpdateFilters}
            isActive={filterState[filt].activeChip.isActive}
            setActiveChipLabel={state.setActiveChipLabel}
          />
        );
      case "MultiSelectSearch":
        return (
          <MultiSelectSearch
            id={filt}
            fieldName={filterState[filt].fieldName}
            title={filterState[filt].title}
            searchTitle={filterState[filt].searchTitle}
            dashboardWidgetSelections={filterState[filt].dashboardWidgetSelections}
            selectedItems={filterState[filt].selectedValue}
            setSelectedItems={state.setMultiSelectSearchSelectedItems}
            checked={filterState[filt].checked}
            setChecked={state.setMultiSelectSearchCheckedItems}
            options={filterState[filt].options}
            setOptions={state.setMultiSelectSearchOptions}
            nameKey={filterState[filt].nameKey}
            valueKey={filterState[filt].valueKey}
            orderingVal={filterState[filt].orderingVal}
            apiUrl={filterState[filt].apiUrl}
            filters={filters}
            updateFilter={updateFilter}
            isActive={filterState[filt].activeChip.isActive}
            setActiveChipLabel={state.setActiveChipLabel}
            showForm={filterState[filt].showForm}
            setShowForm={state.setShowForm}
          />
        );
      case "SearchOptionGroup":
        return (
          <SearchOptionGroup
            id={filt}
            fieldName={filterState[filt].fieldName}
            setValue={state.setSearchOptionGroup}
            value={filterState[filt].selectedValue}
            title={filterState[filt].title}
            customFalseLabel={filterState[filt].customFalseLabel}
            customTrueLabel={filterState[filt].customTrueLabel}
            updateFilter={updateFilter}
          />
        );
      case "DatePicker":
        return (
          <DatePickerFilter
            id={filt}
            fieldName={filterState[filt].fieldName}
            selectedValue={filterState[filt].selectedValue}
            setSelectedValue={state.setDatePickerFilter}
            title={filterState[filt].title}
            updateFilter={updateFilter}
            isActive={filterState[filt].activeChip.isActive}
            setActiveChipLabel={state.setActiveChipLabel}
          />
        );
      case "DateRange":
        return (
          <DateRange
            id={filt}
            fieldName={filterState[filt].fieldName}
            title={filterState[filt].title}
            dateFrom={filterState[filt].currentValues.__gte}
            dateTo={filterState[filt].currentValues.__lte}
            setDateFrom={state.setDateRangeFrom}
            setDateTo={state.setDateRangeTo}
            updateFilter={updateFilter}
            isActive={filterState[filt].activeChip.isActive}
            setActiveChipLabel={state.setActiveChipLabel}
            bulkUpdateFilters={bulkUpdateFilters}
          />
        );
      case "SingleSelect":
        return (
          <SingleSelect
            id={filt}
            fieldName={filterState[filt].fieldName}
            title={filterState[filt].title}
            apiUrl={filterState[filt].apiUrl}
            setValue={state.setSingleSelectGroup}
            value={filterState[filt].selectedValue}
            updateFilter={updateFilter}
            nameKey={filterState[filt].nameKey}
            valueKey={filterState[filt].valueKey}
            orderingVal={filterState[filt].orderingVal}
            isActive={filterState[filt].activeChip.isActive}
            setActiveChipLabel={state.setActiveChipLabel}
          />
        );
      default:
        return "";
    }
  };

  return (
    <div className="h-full overflow-y-auto">
      <List>
        {filterState && Object.keys(filterState).length > 0
          ? Object.keys(filterState).map((filt) => (
              <ListItem key={filt}>{renderFilterUI(filt)}</ListItem>
            ))
          : "No Filters Available"}
      </List>
    </div>
  );
}